"use client";

import React, { useRef } from "react";
import ImageAutoSlider from "@/components/tools/ImageAutoSlider";
import { useGSAP } from "@gsap/react";
import hasFadeAnim from "@/lib/animation/hasFadeAnim";

type Props = {
  brands: { image: string }[];
};

const ClientBrandsSlider = ({ brands }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);

  useGSAP(
    () => {
      hasFadeAnim();
    },
    { scope: containerRef },
  );

  const slides = Array.isArray(brands) ? brands : (brands as any)?.brands || [];

  if (!slides || slides.length === 0) return null;

  return (
    <section
      className="w-full relative section-spacing-top overflow-hidden flex flex-col justify-center bg-transparent"
      ref={containerRef}
    >
      <div
        className="has_fade_anim"
        data-fade-from="bottom"
        data-delay="0.15"
        data-duration="0.70"
        data-on-scroll="0"
      >
        <div className="absolute top-0 left-0 w-12 md:w-24 h-full bg-gradient-to-r from-background to-transparent z-10 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-12 md:w-24 h-full bg-gradient-to-l from-background to-transparent z-10 pointer-events-none"></div>

        <div className="w-full">
          <ImageAutoSlider
            slides={slides}
            width={200}
            height={60}
            imageClassName="object-contain max-h-[40px] md:max-h-[50px] max-w-[120px] md:max-w-[160px] w-auto transition-all duration-500 mix-blend-multiply"
            speed={50}
            className="me-[60px]"
          />
        </div>
      </div>
    </section>
  );
};

export default ClientBrandsSlider;
